<template>
	<div class="logout">
		Logout
	</div>
</template>

<script>
export default {
	name: 'logout',
	mounted: function() {
		this.$store.dispatch('set_auth', null)
		this.$router.push('/')
	}
}
</script>
